export const GOOGLE_WORKSPACE_FORM_FIELDS = {
  clientId: 'client_id',
  clientEmail: 'client_email',
  universeDomain: 'universe_domain',
  privateKey: 'private_key',
};
